import React from "react";

import { ConditionRenderContext } from "src/base-components/FilterPopover/types";
import {
  AssigneeSelect,
  AssigneeSelectOption,
} from "src/cases/queues/AssigneeSelect";
import {
  DELETED_ASSIGNEES_OPTION,
  NO_ASSIGNEE_OPTION,
  useQueueMembers,
} from "src/cases/queues/hooks";
import { CasesPageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const AssigneeValueRenderer: React.FC<ConditionRenderContext> = ({
  groupIndex,
  conditionIndex,
  value,
  onChange,
}) => {
  const { queue_id: queueId } = useParamsDecode<CasesPageParams>();
  const { data: users, isLoading } = useQueueMembers(queueId);

  const options: AssigneeSelectOption[] = [
    NO_ASSIGNEE_OPTION,
    DELETED_ASSIGNEES_OPTION,
    ...users.map((user) => ({ key: user.id, user })),
  ];

  return (
    <AssigneeSelect
      dataLoc={`group-${groupIndex}-condition-${conditionIndex}-assignee`}
      loading={isLoading}
      options={options}
      value={value ?? null}
      onChange={onChange}
    />
  );
};
